import { type IntegrationServiceId } from '../../../../common/integrations'
import { type CrossClientQueryDataSource } from '../../../../models/CrossClient'
import { getCrossClientIntegrationDisplayName } from '../../integrationDisplay'

const AI_RESULT_SOURCE_LABELS = new Map<string, string>([
  ['discussionTopics', 'Zocks - Discussion Topics'],
  ['futureMeetings', 'Zocks - Future Meetings'],
  ['advisorReferral', 'Zocks - Referrals'],
])

type SourceOfType<T extends CrossClientQueryDataSource['type']> = Extract<CrossClientQueryDataSource, { type: T }>

const SOURCE_LABELS: { [T in CrossClientQueryDataSource['type']]: string | ((source: SourceOfType<T>) => string) } = {
  clientProfile: 'Zocks - Client Profile',
  meeting: 'Zocks - Meetings',
  meetingMetadata: 'Zocks - Meeting Metadata',
  task: 'Zocks - Tasks',
  clientMetadata: 'Zocks - Client Metadata',
  aiResult: (source) => AI_RESULT_SOURCE_LABELS.get(source.presetKey) ?? 'Zocks - Meeting Insights',
  integration: (source) => getCrossClientIntegrationDisplayName(source.integrationType as IntegrationServiceId),
}

// Generic over the discriminant so the resolver's parameter stays correlated with the source it is
// handed; indexing the map with the bare union yields resolvers whose parameters intersect to `never`.
const resolveSourceLabel = <T extends CrossClientQueryDataSource['type']>(type: T, source: SourceOfType<T>): string => {
  const label = SOURCE_LABELS[type]
  return typeof label === 'function' ? label(source) : (label ?? '')
}

export const getCrossClientResultDetailSourceLabel = (source: CrossClientQueryDataSource): string => resolveSourceLabel(source.type, source)

export const sortSources = (sources: CrossClientQueryDataSource[]): CrossClientQueryDataSource[] => [...sources].sort((a, b) => a.type.localeCompare(b.type))
